import { render, staticRenderFns } from "./SearchEvents.vue?vue&type=template&id=58a04c8b&scoped=true"
import script from "./SearchEvents.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchEvents.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SearchEvents.vue?vue&type=style&index=0&id=58a04c8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a04c8b",
  null
  
)

export default component.exports